import { lazy } from 'react';

export const AnnouncementsEditor = lazy(() =>
  import(/* webpackChunkName: "AnnouncementsEditor" */ './AnnouncementsEditor').then(
    ({ AnnouncementsEditor: AnnouncementsEditorComponent }) => ({
      default: AnnouncementsEditorComponent,
    }),
  ),
);
